import React from 'react';
import styled from 'styled-components';
import { Theme } from '../../theme';

const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px; /* Reduced from 3px to 2px */
  width: 100%;
  padding: 4px; /* Reduced from 6px to 4px */
  background: ${props => props.theme.background}95;
  border-radius: 6px;
  box-sizing: border-box;
`;

const FilterLabel = styled.div`
  font-size: 9px;
  font-weight: 500;
  color: ${props => props.theme.subText};
  text-transform: uppercase;
  letter-spacing: 0.3px;
  opacity: 0.8;
`;

const InfluencerDropdown = styled.select`
  background: ${props => props.theme.surface};
  color: ${props => props.theme.text};
  border: 1px solid ${props => props.theme.border}60;
  border-radius: 4px;
  padding: 3px 6px; /* Reduced from 4px 8px to 3px 6px */
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;
  box-sizing: border-box;
  
  &:hover, &:focus {
    border-color: ${props => props.theme.primary}80;
    outline: none;
    background: ${props => props.theme.hoverBackground};
  }
  
  option {
    background: ${props => props.theme.background};
    color: ${props => props.theme.text};
    padding: 6px;
  }
`;

interface MobileInfluencerFilterProps {
  theme: Theme;
  selectedInfluencer: string;
  uniqueInfluencers: string[];
  onInfluencerChange: (influencer: string) => void;
  filteredCount: number;
  totalCount: number;
}

const MobileInfluencerFilter: React.FC<MobileInfluencerFilterProps> = ({
  theme,
  selectedInfluencer,
  uniqueInfluencers,
  onInfluencerChange,
  filteredCount,
  totalCount
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onInfluencerChange(event.target.value);
  };

  return (
    <FilterContainer theme={theme}>
      <FilterLabel theme={theme}>
        Filter by Expert
      </FilterLabel>
      <InfluencerDropdown
        theme={theme}
        value={selectedInfluencer}
        onChange={handleChange}
      >
        <option value="all">All Experts ({totalCount})</option>
        {uniqueInfluencers.map(influencer => {
          return (
            <option key={influencer} value={influencer}>
              {influencer}
            </option>
          );
        })}
      </InfluencerDropdown>
    </FilterContainer>
  );
};

export default MobileInfluencerFilter;